import { Button } from "@/components/ui/button";

interface ScaleQuestionProps {
  options: string[];
  currentAnswer: string;
  onAnswer: (answer: string) => void;
}

const ScaleQuestion = ({ options, currentAnswer, onAnswer }: ScaleQuestionProps) => {
  return (
    <div className="w-full max-w-full overflow-hidden">
      {/* Clinical Scale Header */}
      <div className="mb-4 text-center">
        <div className="text-sm font-medium text-muted-foreground mb-2">
          Symptom Intensity Scale
        </div>
        <div className="h-px bg-border"></div>
      </div>
      
      {/* Scale Grid - Responsive Layout */}
      <div className="w-full overflow-x-auto pb-2">
        <div className="flex gap-1 min-w-full justify-between px-1">
          {options.map((option, index) => (
            <Button
              key={index}
              variant={currentAnswer === option ? "default" : "outline"}
              size="sm"
              className={`
                flex-1 min-w-[32px] max-w-[48px] h-10 
                text-xs font-semibold 
                border border-border/60
                transition-all duration-200 ease-in-out
                ${currentAnswer === option 
                  ? "bg-primary text-primary-foreground shadow-sm ring-2 ring-primary/20" 
                  : "bg-background hover:bg-muted/50 hover:border-primary/40"
                }
              `}
              onClick={() => onAnswer(option)}
            >
              {option}
            </Button>
          ))}
        </div>
      </div>
      
      {/* Clinical Scale Labels */}
      <div className="flex justify-between items-center mt-3 px-1">
        <div className="text-xs text-muted-foreground font-medium">
          <span className="inline-block w-2 h-2 bg-green-500/60 rounded-full mr-1.5"></span>
          No Impact
        </div>
        <div className="text-xs text-muted-foreground font-medium">
          Severe Impact
          <span className="inline-block w-2 h-2 bg-red-500/60 rounded-full ml-1.5"></span>
        </div>
      </div>
      
      {/* Scale Guidelines */}
      <div className="mt-3 p-3 bg-muted/30 rounded-lg border border-border/40">
        <p className="text-xs text-muted-foreground leading-relaxed">
          Rate how much this symptom affects your daily activities and quality of life
        </p>
      </div>
    </div>
  );
};

export default ScaleQuestion;